import { render, staticRenderFns } from "./invites.vue?vue&type=template&id=f308ed00&scoped=true"
import script from "./invites.vue?vue&type=script&lang=js"
export * from "./invites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f308ed00",
  null
  
)

export default component.exports